import type { NotifyPort } from '@/features/messages/domain/notify'
import type { ChatPort, Topic } from '../domain/chat'

const createGroup = async (
	port: ChatPort,
	name: string,
	memberIds: string[],
	notify: NotifyPort,
): Promise<Topic | null> => {
	try {
		const topic = await port.createGroup(name.trim(), memberIds)
		notify.success('chat.groupCreated')
		return topic
	} catch {
		notify.error('chat.groupCreateFailed')
		return null
	}
}

export { createGroup }
